import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import './Header.css';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_eventbooth-app/artifacts/q2jc85s9_1768277124501.png';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { user, isAdmin, logout } = useAuth();
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/services', label: 'Services' },
    { path: '/packages', label: 'Packages' },
    { path: '/rentals', label: 'Rentals' },
    { path: '/gallery', label: 'Gallery' },
    { path: '/reviews', label: 'Reviews' },
    { path: '/contact', label: 'Contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="header">
      <div className="header-top">
        <div className="container">
          <div className="header-top-content">
            <a href="tel:+14784842245" className="header-contact">
              <Phone size={14} />
              <span>(478) 484-2245</span>
            </a>
            <a href="mailto:luxelenseventllc@gmail.com" className="header-contact">
              <Mail size={14} />
              <span>luxelenseventllc@gmail.com</span>
            </a>
          </div>
        </div>
      </div>
      
      <nav className="header-nav">
        <div className="container">
          <div className="header-nav-content">
            <Link to="/" className="header-logo">
              <img src={LOGO_URL} alt="Luxe Lens Events" />
            </Link>

            <div className={`header-links ${isMenuOpen ? 'open' : ''}`}>
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`header-link ${isActive(link.path) ? 'active' : ''}`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  {link.label}
                </Link>
              ))}
              
              {user ? (
                <>
                  <Link to="/my-bookings" className="header-link" onClick={() => setIsMenuOpen(false)}>
                    My Bookings
                  </Link>
                  <button onClick={logout} className="header-link btn-text">
                    Logout
                  </button>
                </>
              ) : (
                <Link to="/login" className="header-link" onClick={() => setIsMenuOpen(false)}>
                  Login
                </Link>
              )}
              
              {isAdmin && (
                <Link to="/admin" className="header-link admin-link" onClick={() => setIsMenuOpen(false)}>
                  Admin
                </Link>
              )}
            </div>

            <div className="header-actions">
              <Link to="/book" className="btn btn-primary">
                Book Now
              </Link>
              
              <button
                className="header-menu-toggle"
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                aria-label="Toggle menu"
              >
                {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
              </button>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
}
